import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const ProcessSection = ({ process }) => {
  if (!process || process.length === 0) return null;

  return (
    <section className="py-6 lg:py-8 ">
      <div className="max-w-[1700px] mx-auto px-6 sm:px-8 lg:px-10 xl:px-12">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          viewport={{ once: true }}
          className="mb-8"
        >
          <div className="inline-flex items-center rounded-full bg-gradient-to-r from-orange-100 via-pink-100 to-purple-100 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-orange-600">
            Our Process
          </div>

          <h2 className="mt-4 text-2xl md:text-3xl lg:text-[34px] font-bold leading-tight text-gray-900">
            Our Delivery Process
          </h2>

          <div className="mt-3 h-1 w-16 rounded-full bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6]" />

          <p className="mt-4 max-w-5xl text-[15px] leading-7 text-gray-600 ">
            Every project follows a structured AI implementation process,
            ensuring transparency, quality, and successful delivery from
            planning to deployment.
          </p>
        </motion.div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="hidden md:block absolute left-[18px] top-0 bottom-0 w-[2px] rounded-full bg-gradient-to-b from-[#FF7A18] via-[#EC4899] to-[#8B5CF6]" />

          <div className="space-y-5">
            {process.map((item, index) => {
              const step =
                item.step || String(index + 1).padStart(2, "0");

              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{
                    duration: 0.4,
                    delay: index * 0.08,
                  }}
                  viewport={{ once: true }}
                  className="relative flex items-start gap-4"
                >
                  {/* Step Number */}
                  <div className="relative z-10 flex-shrink-0">
                    <div className="flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-lg bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6] text-sm font-bold text-white shadow-md">
                      {step}
                    </div>
                  </div>

                  {/* Card */}
                  <motion.div
                    whileHover={{ y: -3 }}
                    transition={{ duration: 0.2 }}
                    className="group flex-1 rounded-xl border border-gray-200  p-4 md:p-5 shadow-sm transition-all duration-300 hover:border-[#EC4899]/40 hover:shadow-md"
                  >
                    <div className="flex items-start justify-between gap-4 ">
                      <div className="flex-1">
                        <h3 className="text-lg font-bold text-gray-900 transition-colors duration-300 group-hover:text-[#EC4899]">
                          {item.title}
                        </h3>

                        <p className="mt-2 text-[15px] leading-6 text-gray-600">
                          {item.desc}
                        </p>
                      </div>

                      <ArrowRight
                        size={18}
                        className="mt-1 flex-shrink-0 text-[#EC4899] transition-transform duration-300 group-hover:translate-x-1"
                      />
                    </div>

                    {/* Bottom Accent */}
                    <div className="mt-4 h-[3px] w-10 rounded-full bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6] transition-all duration-300 group-hover:w-16" />
                  </motion.div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;